import React, { FC, useState, useEffect } from "react";
import { Button, message, Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useSupplierOfferModel } from "./supplierOfferModel";
import { useOfferDetailModel } from "@/views/inquires/offer/view/details/offerDetailModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { usePurchasesDetailModel } from "@/views/purchases/view/details/purchasesDetailModel";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, setSupplierDialog, dispbleOffer, transferOffer,
    } = useSupplierOfferModel();
    const { replaceNav } = useNavModel(() => []);
    const { updateFormVal } = useOfferDetailModel(() => []);
    const { getTreeNodeName } = useDictModel(() => []);
    const { updateFormVal: purchaseUpdateFormVal } = usePurchasesDetailModel(() => []);

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '供应商报价编码',
            width: 160,
            dataIndex: 'code',
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
        }, {
            title: '状态',
            width: 160,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '报价时间',
            width: 160,
            dataIndex: 'createTime',
        }, {
            title: '报价总金额',
            width: 160,
            dataIndex: 'amountTotal',
        }, {
            title: '联系人',
            width: 160,
            dataIndex: 'contact',
        }, {
            title: '联系电话',
            width: 160,
            dataIndex: 'phone',
        },
    ];

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.I_ED_ED_QUOTE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    transferOffer().then(res => {
                        if (res) {
                            //转报价单页面
                            replaceNav("2-1-1", "2-2-2", { id: res as string, mode: "edit" });
                            updateFormVal("edit", null);
                        }
                    })
                }}
            >出口报价</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.I_ED_PURCHASE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        return message.warning("请选择单条数据进行转采购合同");
                    }
                    //转报采购合同新增页
                    replaceNav("2-1-1", "4-1", { id, mode: "add" });
                    purchaseUpdateFormVal("add", null);
                }}
            >转采购合同</Button>
        </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.I_ED_ED_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => setSupplierDialog({ visible: true, mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.I_ED_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        return message.warning("请选择单条数据进行编辑");
                    }
                    setSupplierDialog({ visible: true, mode: "edit" })
                }}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.I_ED_ED_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        return message.warning("请选择单条数据进行编辑");
                    }
                    dispbleOffer()
                }}
            >作废</Button>
        </YhAuth>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { }}
        >导出</Button> */}
    </>

    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <YhBox title=" " style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowKey={record => record.code}
                rowSelection={{
                    //全部选中时  (存string[])
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        let changeRowId = changeRows.map(item => item.code);
                        selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                            : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                    },
                    onSelect: (record) => onRow(record.code),
                    selectedRowKeys: selectedRowKeys
                }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record.code),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        setSelectedRowKeys([record.code]);
                    }
                })}
                scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
            />
        </YhBox>
    )
}
